import attachmentsReducers from './reducer';
import * as attachmentsActions from './reducer';

export { attachmentsActions };

export default attachmentsReducers;
